import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SubRowContent from './RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Stack } from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const BasicInformation = (props: Props) => {
  const { disabled, register, watch, setValue, getValues } = props;

  const contents = [
    {
      label: 'Nghề nghiệp',
      element: (
        <Form.MuiTextField
          {...register('basic_information.occupation')}
          required={false}
          disabled={disabled}
          placeholder="Nhập"
        />
      ),
    },
    {
      label: 'Loại bảo\nhiểm',
      element: (
        <Form.MuiRadioGroup
          i18nKey="HOME_CARE.INSURANCE_TYPE"
          values={[1, 2, 3]}
          disabled={disabled}
          defaultValue={getValues('basic_information.insurance_type')}
          onChange={v => setValue('basic_information.insurance_type', v)}
        />
      ),
    },
    {
      label: 'Nơi cư trú',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.RESIDENCE"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('basic_information.residence')}
            onChange={v => setValue('basic_information.residence', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.residence_etc')}
            required={false}
            disabled={disabled}
            placeholder="Nhập"
          />
        </Stack>
      ),
    },
    {
      label: 'Tôn giáo',
      element: (
        <Form.MuiTextField
          {...register('basic_information.religion')}
          required={false}
          disabled={disabled}
          placeholder="Nhập"
        />
      ),
    },
    {
      label: 'Dịch vụ điều\ndưỡng',
      element: (
        <Form.MuiTextField
          {...register('basic_information.nursing_provider')}
          required={false}
          disabled={disabled}
          placeholder="Nhập"
        />
      ),
    },
    {
      label: 'Vệ sinh',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.SANITARY"
            values={[1, 2]}
            disabled={disabled}
            defaultValue={getValues('basic_information.sanitary')}
            onChange={v => setValue('basic_information.sanitary', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.sanitary_notes')}
            required={false}
            disabled={disabled}
            placeholder="Nhập"
          />
        </Stack>
      ),
    },
    {
      label: 'Tình trạng\nhôn nhân',
      element: (
        <Form.MuiTextField
          {...register('basic_information.marital_status')}
          required={false}
          disabled={disabled}
          placeholder="Nhập"
        />
      ),
    },
    {
      label: 'Lịch sử',
      element: (
        <Form.MuiTextField
          {...register('basic_information.past_history')}
          required={false}
          disabled={disabled}
          placeholder="Nhập"
        />
      ),
    },
    {
      label: 'An ninh',
      element: (
        <Stack direction="row" spacing={1}>
          <Form.MuiRadioGroup
            i18nKey="HOME_CARE.SAFETY"
            values={[1, 2]}
            disabled={disabled}
            defaultValue={getValues('basic_information.safety')}
            onChange={v => setValue('basic_information.safety', v)}
            width="auto"
          />
          <Form.MuiTextField
            {...register('basic_information.safety_notes')}
            required={false}
            disabled={disabled}
            placeholder="Nhập"
          />
        </Stack>
      ),
    },
  ];

  return (
    <>
      <SectionTitle title="Thông tin cơ bản" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (label === 'Loại bảo\nhiểm') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === 'Dịch vụ điều\ndưỡng') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          } else if (label === 'Tình trạng\nhôn nhân') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={0.8}
                  childrenRatio={3.1}
                >
                  {element}
                </SubRowContent>
              </>
            );
          }
          return (
            <>
              <RowContent title={label} titleRatio={0.8} childrenRatio={3.1}>
                {element}
              </RowContent>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default BasicInformation;
